import { render, staticRenderFns } from "./AppNotLive.vue?vue&type=template&id=663553ac&scoped=true&"
import script from "./AppNotLive.vue?vue&type=script&lang=js&"
export * from "./AppNotLive.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AppNotLive.vue?vue&type=style&index=0&id=663553ac&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "663553ac",
  null
  ,true
)

export default component.exports